import React from 'react';
import { LoginForm } from '../../components';

import back1 from '../../assets/images/back_login1.jpg';
import back2 from '../../assets/images/back_login2.jpg';
import back3 from '../../assets/images/back_login3.jpg';

import './Login.css';

// Random background
const rand = parseInt(Math.random() * 1000, 10);
const back = rand % 3 === 1 ? back1 : (rand % 3 === 2 ? back2 : back3);

const Login = () => {
    return (
        <div className="Login text-center">
            <div className="wrapper">
                <div className="background" style={{ backgroundImage: "url(" + back + ")"}} ></div>
                <LoginForm appear />
            </div>
        </div>
    );
}

export default Login;
